import React, { useEffect, useState } from 'react';
import '../css/makeTable.css';
import { getData } from '../store/utils';
import Loader from '../component/Loader';
import Swal from "sweetalert2";

function ElectricianOrdersDetails() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const orderId = urlSearchParams.get("orderId");
  const [electricianOrderData, setElectricianOrderData] = useState([]);
  const [isLoadingOn, setIsLoadingOn] = useState(false);

  async function merchantGetData() {
    if (orderId) {
      setIsLoadingOn(true);
      const tempData = await getData(`electricianOrders/getElectricianOrderById?orderId=${orderId}`);
      setIsLoadingOn(false);
      if (tempData.statusCode === 200) {
        setElectricianOrderData(tempData?.data || []);
      } else {
        Swal.fire({
          title: "Error!",
          text: tempData.data?.errors?.msg || "Something went wrong",
        });
      }
    }
  }

  useEffect(() => {
    merchantGetData();
  }, [orderId]);

  return (
    <div>
      {isLoadingOn ? <Loader /> : ""}
      <div className='merchantDetailsHeading'>
        <h4>Electrician Orders Details</h4>
      </div>

      {electricianOrderData.length > 0 ? electricianOrderData.map((item, index) => (
        <div className="accordion mb-3" key={item.id || index} id={`accordionPanelsStayOpenExample-${index}`}>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target={`#panelsStayOpen-collapseOne-${index}`}
                aria-expanded="true" aria-controls={`panelsStayOpen-collapseOne-${index}`}>
                Electrician Orders Details : ID = {item.id}
              </button>
            </h2>
            <div id={`panelsStayOpen-collapseOne-${index}`} className="accordion-collapse collapse show">
              <div className="accordion-body">
                <div className="merchantdesignlay">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.orderId || "-"}</h5><p>Order Id</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.electricianName || "-"}</h5><p>Electrician Name</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.distributorName || "-"}</h5><p>Distributor Name</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.productName || "-"}</h5><p>Product Name</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.brand || "-"}</h5><p>Brand</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.size || "-"}</h5><p>Size</p></div></div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.color || "-"}</h5><p>Color</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.quantity || "-"}</h5><p>Quantity</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.amount || "-"}</h5><p>Amount</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.discount || "-"}</h5><p>Discount</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.total || "-"}</h5><p>Total</p></div></div>
                      <div className="col-md-2"><div className='merchantNameDetails'><h5>{item.createdAt || "-"}</h5><p>Created At</p></div></div>
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )) : (
        !isLoadingOn && <div className="text-center my-4">No data found.</div>
      )}
    </div>
  );
}

export default ElectricianOrdersDetails;
